import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from '@/components/ui/toast'
import { signOut } from '@/lib/auth-client'

/**
 * Shared admin sign-out: clears Better Auth session + React Query cache,
 * then returns to `/login` so staff can switch accounts.
 */
export function useSignOut() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const [isSigningOut, setIsSigningOut] = useState(false)

  const handleSignOut = async () => {
    if (isSigningOut) return
    setIsSigningOut(true)
    try {
      const result = await signOut()
      if (result?.error) throw new Error(result.error.message)
      queryClient.clear()
      await navigate({ to: '/login', replace: true })
    } catch {
      toast.error("Couldn't sign out. Check your connection and try again.")
      setIsSigningOut(false)
    }
  }

  return { signOut: handleSignOut, isSigningOut }
}
